import http from '@/communication/AuthConnection'

export default async ({ eventId }) => {
  const result = await http.get(`/v1/event/proposal-info/${eventId}`)
  return Promise.resolve(result.data.eventInfo)
}



// WEBPACK FOOTER //
// ./src/brain/event/GetProposalInfo.js